import { useEffect, useState } from "react";

import { delay } from "../../../../utils";
import { callSocket } from "../../../../utils/socket"

import CustomButton from "../../../../common/CustomButton";
import useSVG from "../../../../hooks/useSVG";

function InAppNotification(props) {
    const { UseProgramSVG, UseChalengesSVG, UseNumberSVG, IndiLogo, StreakSVG } = useSVG();

    const { gradient, icon, title, progress } = props;

    const [fshow, setFShow] = useState({
        s1: false,
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
    });

    let svg = null;
    if (icon?.type == "program") {
        svg = UseProgramSVG(icon?.svg);
    } else if (icon?.type == "challenge") {
        svg = UseChalengesSVG(icon?.svg);
    } else if (icon?.type == "number") {
        svg = UseNumberSVG("n" + props?.progress?.workoutsCompleted);
        // svg = UseNumberSVG("n500");
    } else if (icon?.type == "streak") {
        svg = StreakSVG;
    }

    useEffect(() => {

        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s1: true
                }
            });
        }, 400)
        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s2: true
                }
            });
        }, 800)
        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s3: true
                }
            });
        }, 1200)
        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s4: true
                }
            });
        }, 1600)
        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s5: true
                }
            });
        }, 2000)
        delay(() => {
            setFShow((fv) => {
                return {
                    ...fv,
                    s6: true
                }
            });
        }, 2400)

    }, [])

    return (
        <div id="in-app-notification" style={{ backgroundImage: `linear-gradient(to right, ${gradient?.[0]}, ${gradient?.[1]})` }}>

            <div id="ian-header-wrapper">
                <h5 className={`flip ${fshow.s1 ? "fshow" : ""}`}>@indimoves</h5>
                <div className={`flip ${fshow.s2 ? "fshow" : ""}`} id="ian-icon">
                    {svg}
                </div>
                <div className={`flip ${fshow.s3 ? "fshow" : ""}`}>
                    {IndiLogo}
                </div>
                <h4 className={`flip ${fshow.s4 ? "fshow" : ""}`}>{title}!</h4>
            </div>

            <div className={`flip ${fshow.s5 ? "fshow" : ""}`} id="ian-progress-wrapper">
                <h5>SINCE JOINING</h5>
                <div id="ian-progress">
                    <div>
                        <h1>{props?.progress?.workoutsCompleted}</h1>
                        <div>
                            <h6>Workouts</h6>
                            <h6>Completed</h6>
                        </div>
                    </div>
                    <div>
                        <h1>{props?.progress?.activeMinutes}</h1>
                        <div>
                            <h6>Active</h6>
                            <h6>Minutes</h6>
                        </div>
                    </div>
                </div>
            </div>

            <div id="ian-footer" className={`flip ${fshow.s6 ? "fshow" : ""}`}>
                {
                    props?.showShareButton &&
                    <CustomButton onClick={() => {
                        callSocket("/interact-native-app-share", { type: "screenshot", ianID: props?.ianID });
                        props?.setShowShareButton(false);
                    }}>SHARE</CustomButton>
                }
            </div>
        </div>
    );
}

export default InAppNotification;